package com.macrofocus.eflux.diagram

enum class DiagramType {
    Schematic,
    Tube,
    Geo,
    ThreeD,
    Table
}